import React from "react";
import { Box, IconButton, StarIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const RoundedIconButton = () => {
  return (
    <Box p={3} sx={{ width: "80%", margin: "0 auto" }}>
      <PreviewAndEditor
        background
        title={"Rounded IconButtons"}
        height={"150px"}
        language={"js"}
        value={
          '        <IconButton variant={"rounded"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"primary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"secondary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"error"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"warning"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"info"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"success"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"inherit"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} color={"inheritWhite"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"rounded"} disabled>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>"
        }
      >
        <IconButton variant={"rounded"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"primary"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"secondary"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"error"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"warning"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"info"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"success"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"inherit"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} color={"inheritWhite"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"rounded"} disabled>
          <StarIcon />
        </IconButton>
      </PreviewAndEditor>
    </Box>
  );
};

export default RoundedIconButton;
